module.exports = __webpack_public_path__ + "staticcomp/img/brief_down.51cb2c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brief_down.png
// module id = Lv9F
// module chunks = 39